import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FmGalleryLayout, FmMessage, FmText } from "../../../Components";
import { ANONYMOUS_ROUTES } from "../../../Constants";
import { AuthState } from "../../../Redux";
import { useQuery } from "../../../Redux/Hooks/Hooks";
import { updatePasswordThunk, validateResetPasswordTokenThunk } from "../../../Redux/States/Auth/AuthThunk";
import { UpdatePasswordForm } from "./Components/UpdatePasswordForm";
import useStyles from "./UpdatePasswordPage.style";

const UpdatePasswordPage = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const query = useQuery();
    const token = query.get("token");
    const username = query.get("userId");

    const { updatePasswordPageError, updatePasswordPageIsLoading, updatePasswordApproved } = useSelector(AuthState.Selectors.selectUpdatePasswordStatus);

    useEffect(() => {
        (window as any).dataLayer.push({
            event: "UpdatePassword",
            pageUrl: "https://multimatch.haifa-group.com/multi-match/auth/update_password",
            pageTitle: "UpdatePassword",
        });
    }, []);
    useEffect(() => {
        if (updatePasswordPageError === undefined) {
            dispatch(validateResetPasswordTokenThunk(username ? username : "", token ? token : ""));
        }
    }, [updatePasswordPageError]);

    useEffect(() => {
        if (updatePasswordApproved) {
            setTimeout(() => {
                history.replace(ANONYMOUS_ROUTES.AUTH);
            }, 3000);
        }
    }, [updatePasswordApproved]);

    const onUpdatePassword = async (password: string) => {
        if (username && token) {
            await dispatch(updatePasswordThunk(username as string, token as string, password));
        }
    };

    return (
        <FmGalleryLayout>
            <div className={classes.container}>
                <div className={classes.content}>
                    <div className={classes.titles_container}>
                        <FmText variant={"bigTitle"}>{t("updatePassword.title")}</FmText>
                        <span className={classes.textSmallWidth}>{t("signUp.passwordNote")}</span>
                    </div>
                    <UpdatePasswordForm onSubmit={onUpdatePassword} loading={updatePasswordPageIsLoading} error={!!updatePasswordPageError} />
                    {updatePasswordApproved && (
                        <FmMessage className={classes.message} variant={"success"}>
                            {t(`updatePassword.success`)}
                        </FmMessage>
                    )}
                </div>
            </div>
        </FmGalleryLayout>
    );
};

export default UpdatePasswordPage;
